export default __webpack_public_path__ + "static/media/dev.6c569f9e.png";